export default "__VITE_ASSET__DOQiQiXl__"